import branDani from './photos/branDani.JPG';

const DogWalkers = () => {

    return (
        <div>
            <div className="section-content-container">
                <h1 className="titles">DogWalkers</h1>
                <p className="about-subtitle"> Hi! My name is Brandon Hernandez </p>
                <img src={branDani} className="branDani-image" alt="Brandon and Danielle Hernandez" />
                <hr className="section-divider" />
                <p className='text-content'>
                    I am based in the Fairview area with my wife. I am here to make sure that your dog has a great time and is able 
                    to have an experience that is familiar and fun.<br /> <br />
                    The route that I will take is your desired route. However, if you don't have any specific route,
                    I will create one that is fun and engaging for your dog to enjoy. <br /> 
                    <br />
                    Your AlphaWalk will be personalized according to your dogs needs.
                    <br />
                    I look foward to take an Alpha DogWalk with your AlphaDog!
                </p>
  
            
            </div>
        </div>
        
    )


}

export default DogWalkers;